import { useMemo } from 'react';
import Button from '@/trio-ui/Button';
import * as Styles from './ErrorMessage.styles';

type ErrorMessageProps = {
  aboveTitle?: string;
  title: string;
  description: string | JSX.Element;
  illustration?: string;
  buttonLabel?: string;
  buttonAction?: () => void;
};

const ErrorMessage = ({
  title,
  aboveTitle = 'Oh-oh',
  description,
  illustration,
  buttonAction,
  buttonLabel,
  ...props
}: ErrorMessageProps): JSX.Element => {
  const renderDescription = useMemo(() => {
    if (typeof description === 'string') {
      return <Styles.SubTitle>{description}</Styles.SubTitle>;
    }
    return <Styles.Description>{description}</Styles.Description>;
  }, [description]);

  return (
    <Styles.Content data-testid="error-page-message" {...props}>
      <Styles.AboveTitle>{aboveTitle}</Styles.AboveTitle>
      {illustration && <Styles.Img src={illustration} alt={title} />}
      <Styles.Title>{title}</Styles.Title>
      {renderDescription}
      {buttonLabel && buttonAction && (
        <Button size="medium" variantColor="yellow" onClick={buttonAction}>
          {buttonLabel}
        </Button>
      )}
    </Styles.Content>
  );
};

export default ErrorMessage;
